import { NgModule } from '@angular/core';
import { LIB_CommonModule } from 'pbc.angular';
import { PostDurchgangCommandService } from '.';

@NgModule({
  imports: [
    LIB_CommonModule,
  ],
  providers: [PostDurchgangCommandService],
  exports: []
})
export class PostDurchgangCommandServiceModule { }
